import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from '@apollo/client';
import { LogoutModal } from '@src/components/LogoutModal';
import { IS_ELIGIBLE } from '@src/graphql/queries/benefits';
import { useAuth } from '@src/hooks/useAuth';
import { LoginActivityMonitor, getRegionAndClient, getCookie } from 'pe-core-frontend';
import { createContext, useEffect, useState } from 'react';
const DefaultEmployeeContext = {};
export const EmployeeContext = createContext(DefaultEmployeeContext);
export const EmployeeContextProvider = ({ children }) => {
    const { currentUser } = useAuth();
    const hasEmployeeId = currentUser?.employeeId !== undefined && currentUser?.employeeId !== null;
    const { data, loading: eligibilityLoading } = useQuery(IS_ELIGIBLE, {
        skip: !currentUser || !hasEmployeeId,
    });
    const isEligible = data?.isEligible ?? false;
    const [currentAuthProvider, setCurrentAuthProvider] = useState();
    useEffect(() => {
        const { region, client } = getRegionAndClient();
        // currently this cookie is only set when user logs in via Guild Auth
        const authProvider = getCookie(`guild-global_${region}_${client}_auth_provider`);
        setCurrentAuthProvider(authProvider ? authProvider : undefined);
    }, [isEligible]);
    const value = {
        ...DefaultEmployeeContext,
        isEligible,
        eligibilityLoading,
        currentAuthProvider,
    };
    return (_jsx(EmployeeContext.Provider, { value: value, children: _jsx(LoginActivityMonitor, { LogoutModal: LogoutModal, children: children }) }));
};
